import { OnInit, Component, Input, Injector, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainComponent } from '../main-component/main.component';
import { ModalSize } from '../../services/smart-modal.service';
import { FormComponent } from '../form/form.component';
import { AsideBarService } from '../../services/asideBar.service';
import { AsideUiEngineComponent } from '../aside-ui-engine/aside-ui-engine.component';
import { CommonService } from '../../services/common.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'dhs-form-grid',
    templateUrl: './form-grid.component.html',
    styleUrls: ['./form-grid.component.scss'],
    standalone: false
})
export class FormGridComponent extends MainComponent implements OnInit {
    @ViewChild('formComponenet') formComponenet: FormComponent;
    @Input() resourceName: any;
    @Input() banner: any;
    @Input() addAllowed: any = true;
    @Output() editEllipseClick: EventEmitter<any> = new EventEmitter();
    @Output() bulkActionClicked = new EventEmitter<any>();
    public _currentData: any = {};
    @Input() parent_id: any;
    @Input() layoutName: any;
    @Input() config: any = {loadedBindGrid:false};
    @Input() currentData: any;
    currentConfig: any = {};
    editonPage: boolean = false;
    resourceDef: any;
    docUrl: any;
    constructor(
        public route: ActivatedRoute,
        public injector: Injector,
        public router: Router,
        public asideBarService: AsideBarService,
        public commonService?: CommonService,
        private sanitizer?:DomSanitizer
    ) {
        super(injector, route);
    }

    initFormList() {
        this._currentData.configList = {
            "viewAll": true,
            "hideSearchBox": false,
            "hideResult": false,
            "allowPagination": true,
        }
        this._currentData.config = {
            "submitButton": true,
            "cancelButton": true,
            "filterForm": false,
            "clearOnSave": false,
            "delegateSave": true,
            "cancelRoute": ''
        }
    }

    tiltIcon(){
        if(!this._currentData.tilt)
            this._currentData.tilt = true;
        else
            this._currentData.tilt = false;
    }

    ngOnInit() {
        this.uiInit();
    }
    uiInit(config?,callback?){
        if (this._currentData.origArhiveConfig == undefined) {
            let archiveConfig:any = false;
            if (this._currentData.archiveConfig != undefined && config && config["archiveConfig"] != undefined && config["archiveConfig"].resource != undefined) {
              archiveConfig = this._currentData.archiveConfig;
            }
            this.initCurrentData();
            if (config && config["archiveConfig"] != undefined) {
                if(archiveConfig){
                  this._currentData["archiveConfig"] = archiveConfig;
                }else{
                  this._currentData["archiveConfig"] = {};
                }        
                this._currentData["archiveConfig"]["selected"] = config["archiveConfig"];
                this._currentData["archiveConfig"]["applied"] = true;
            }
            if (this.resourceName) {
                this._currentData.resource = this.resourceName;
                this._currentData.json = this._currentData.resource;
            } else if (this.route.snapshot.params.resource != undefined) {
                this._currentData.resource = this.route.snapshot.params.resource;
                this._currentData.json = this._currentData.resource;
            } else if (false) {
                //TODO: handle input data here
            }
            //Archive in case of schema is change, then all json will be overridden with archive config resource
            if(config && config.archiveConfig != undefined &&  config["archiveConfig"].resource != undefined){
                this._currentData.resource = config["archiveConfig"].resource;
                this._currentData.json = this._currentData.resource;
            }
        }else {
            //archive is loading
            var origArhiveConfig = JSON.parse(JSON.stringify(this._currentData.origArhiveConfig));
            this.initCurrentData();
            this._currentData.origArhiveConfig = origArhiveConfig;
            this._currentData.json = this._currentData.origArhiveConfig.resource;
        }
        this._currentData.bookmarks = undefined;
        this.initFormList();
        if (!this.parent_id) {
            this.parent_id = 0;
        }
       
        if (this.currentData) { // Set default value in form data if any
            this._currentData.currentData = this.currentData;
        }
        this._currentData.tilt = false;
        this._currentData.currentAction = 'ADD';
        this.baseService.getResourceDef(this._currentData.json, (resourceDef) => {
            if (resourceDef) {
                if (this._currentData.origArhiveConfig != undefined) {
                    if (resourceDef.config == undefined) {
                      resourceDef.config = {};
                    }
                    this._currentData.gridData.page_no = 0;//resetting page
                    resourceDef.config.archive = this._currentData.origArhiveConfig;
                    resourceDef.config.archive.isON = true;
          
                 }
                 if(config && config.archiveConfig != undefined &&  config["archiveConfig"].resource != undefined && this._currentData["archiveConfig"] != undefined){
                    if (resourceDef.config == undefined) {
                      resourceDef.config = {};
                    }
                    resourceDef.config.archiveConfig = this._currentData["archiveConfig"]
                  }
                this.loadInitalConfig(this._currentData.json, () => {      
                    if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
                        var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: resourceDef }, this._currentData.uiConfigData);
                        if (afterConfig.resouceDef != undefined) {
                            resourceDef = afterConfig.resouceDef;
                        }
                    }
                    this.utilService.checkIfArchiveAvailable(resourceDef,this);
                    this.resourceDef = resourceDef;
                    this._currentData.currentResource = resourceDef.resource;
                    this._currentData.configList.resource = resourceDef.resource;
                     /******** DEOCRATOR IMPLEMENTATION *******/
                    if (resourceDef.config != undefined && resourceDef.config.decorator != undefined) {
                        this._currentData.decorator = this.baseService.initDecorator(resourceDef.config.decorator, this.route, this.injector);
                    }
                    /******** DEOCRATOR IMPLEMENTATION *******/
                    if (this._currentData.decorator != undefined && this._currentData.decorator && resourceDef.list.complex_search) {
                        this._currentData.decorator.complexSearchManipulation(resourceDef.list.complex_search, (val) => {
                          if (val) {
                            this._currentData.configList.complex_search = val;
                          }
                        });
                      }else
                        this._currentData.configList.complex_search = resourceDef.list.complex_search;
                    // this._currentData.configList.complex_search = resourceDef.list.complex_search;
                    this._currentData.configList.printActions = resourceDef.list.printActions;
                    this._currentData.configList.save_filter = (resourceDef && resourceDef?.config && resourceDef?.config?.save_filter) ? true : false
                    this._currentData.configList.allowConfigGrid = resourceDef != undefined && resourceDef.config != undefined && resourceDef.config.configure_grid != undefined ? resourceDef.config.configure_grid : true;
                    this._currentData.configList.limit = this._currentData.gridData.page_size;
                    this._currentData.configList.ehr_view = resourceDef && resourceDef.config && resourceDef.config.ehr_view ? true : false
                    this._currentData.configList.ehr_view_default = resourceDef && resourceDef.config && resourceDef.config.ehr_view_default ? true : false
                    this._currentData.configList.secondary_uhid = resourceDef && resourceDef.config && resourceDef.config.secondary_uhid ? true : false
                    this._currentData.configList.secondary_uhid_default = resourceDef && resourceDef.config && resourceDef.config.secondary_uhid_default ? true : false
                    this._currentData.configList.view_current_data = resourceDef && resourceDef.config && resourceDef.config.view_current_data ? resourceDef.config.view_current_data : false;
                    this._currentData.configList.readPreference = resourceDef && resourceDef.config && resourceDef.config.readPreference != undefined ? resourceDef.config.readPreference : false;
                    
                    /**************ARCHIVE CONFIG *******/
                    if (this._currentData.archiveConfig != undefined) {
                        this._currentData.configList.archiveConfig = this._currentData.archiveConfig;
                    }
                    /**************ARCHIVE CONFIG *******/
                    if (resourceDef.config) {
                        this._currentData.config["relayInfo"] = resourceDef.config.relay_info ? this.resourceDef.config.relay_info : false;
                        if (this._currentData != undefined && this._currentData.configList != undefined) {
                            this._currentData.configList['hideSearchBox'] = resourceDef != undefined && resourceDef.config != undefined && resourceDef.config.hideSearchBox != undefined ? resourceDef.config.hideSearchBox : false;
                        }
                        this.editonPage = resourceDef.config.form_grid_update ? resourceDef.config.form_grid_update : false;
                    }
                    this.baseService.setTitleFromResouceDef(resourceDef, this._currentData.currentAction); // Set Page name,title
                    //assign action and other data here
                    this.currentConfig = resourceDef.config ? resourceDef.config : {};
                    this.currentConfig['formType'] = resourceDef.config != undefined && resourceDef.config['formType'] != undefined ? resourceDef.config['formType'] : "default";
                    this.currentConfig['showNavigationAfterBanner'] = resourceDef.config && resourceDef.config.showNavigationAfterBanner? resourceDef.config.showNavigationAfterBanner : false;
                    if (resourceDef.config != undefined && resourceDef.config['print_allowed'] != undefined) {
                        this._currentData.configList.print_allowed = resourceDef.config['print_allowed'];
                    }
                    if (resourceDef.list != undefined && resourceDef.list['print_allowed'] != undefined) {
                        if (this._currentData.configList.print_allowed != undefined) {
                            this._currentData.configList.print_allowed = { ...this._currentData.configList.print_allowed, ...resourceDef.listresourceDef.list['print_allowed']['print_allowed'] };
                        } else {
                            this._currentData.configList.print_allowed = resourceDef.list['print_allowed'];
                        }
                    }

                    if (this.currentConfig.aside_container != undefined)
                        this._currentData.config.aside_container = true
                    this.getDataForCurdOperation(resourceDef);
                    if(callback){
                        callback();
                    }
                });
               
            }
        });
        this.refreshFunction();
    }

    ngOnDestroy() {
        this.asideBarService.removeComponent();
        localStorage.removeItem("favoriteExpand");
    }
    getDataForCurdOperation(resouceDef) {
        this._currentData.resouceDef = resouceDef;
        // localStorage.setItem("CurrentResource", resouceDef.resource);
        this.storageService.setCurrentResource(resouceDef.resource)
        this._currentData.resource = resouceDef.resource;
        if (this.route.snapshot.queryParams.hasOwnProperty('banner')) {
            this._currentData.bannerJson = JSON.parse(this.route.snapshot.queryParams.banner);
            this._currentData.showBanner = true;
        } else if (this.banner != undefined && this.banner) {
            this._currentData.bannerJson = this.banner;
            this._currentData.showBanner = true;
        } else if (resouceDef.banner != undefined && resouceDef.banner) {
            this._currentData.bannerJson = resouceDef.banner;
            this._currentData.showBanner = true;
        }
        this._currentData.configList['bannerJson'] = this._currentData.bannerJson != undefined && this._currentData.bannerJson ? this._currentData.bannerJson : "";
        this._currentData.configList['showBanner'] = this._currentData.showBanner != undefined && this._currentData.showBanner ? resouceDef.config != undefined && resouceDef.config['hidePrintBanner'] != undefined && resouceDef.config['hidePrintBanner'] ? false : this._currentData.bannerJson : false;
        if (resouceDef.form) {
            this.baseService.getReferredField(resouceDef.form, (response) => {
                console.log("Response is ", response);
                this._currentData.currentFormFields = {};
                if (resouceDef.form.id)
                    this._currentData.currentFormFields.id = resouceDef.form.id;
                this._currentData.currentFormFields.bannerJson = this._currentData.bannerJson
                this._currentData.currentFormFields.blocks = response;
                if (resouceDef.form.hasOwnProperty('APIresource')) {
                    this._currentData.currentFormFields.APIresource = resouceDef.form.APIresource;
                }
                if (resouceDef.form.hasOwnProperty('submitButton')) {
                    this._currentData.currentFormFields.submitButton = resouceDef.form.submitButton;
                } else {
                    this._currentData.currentFormFields.submitButton = true;
                }
                if (resouceDef.form.hasOwnProperty('init_resource')) {
                    this._currentData.currentFormFields.init_resource = resouceDef.form.init_resource;
                }
                console.log("Form Fields ", this._currentData.currentFormFields);
                this._currentData.customButton = resouceDef.custom_button || {
                    "Add": [
                        {
                            "label": "button.submit",
                            "icon": "fa fa-check"
                        }
                    ],
                    "Modify": [
                        {
                            "label": "button.update",
                            "icon": "fa fa-check"
                        }
                    ]
                };
                if (resouceDef.form.bookmark && this._currentData.bookmarks == undefined) {
                    this._currentData.bookmarks = {};
                    this._currentData.bookmarks.bookmark = resouceDef.form.bookmark;
                    this._currentData.bookmarks.bannerJson = this._currentData.bannerJson;

                }
            });
        }
        if (resouceDef.list.filter != null) {
            if (resouceDef.list.filter.default_filter != undefined) {
                this._currentData.default_filter = resouceDef.list.filter.default_filter
            }
            else {
                this._currentData.default_filter = false
            }
            this.baseService.getResourceDef(resouceDef.resource, (response) => {
                console.log("Response is ", response);
                this._currentData.currentFilterListFormFields = {};
                this._currentData.currentFilterListFormFields.blocks = response;
                console.log("response at ui engine as pewr data grid", response);
                // ADD THESE LINES TO PASS quick_filters if exists
                if (resouceDef?.list?.filter?.quick_filters) {
                    this._currentData.currentFilterListFormFields.quick_filters = resouceDef?.list?.filter?.quick_filters;
                }
            });
        } else {
            this._currentData.currentFilterListFormFields = null;
        }
        this._currentData.currentListFields = resouceDef.list.fields;
        if (resouceDef.list && resouceDef.list.gridButtons != undefined) {
            if (this._currentData.currentListFields.find(elem => (elem.name == 'gridButton')) == undefined) {
                resouceDef.list.gridButtons.name = "gridButton";
                this._currentData.currentListFields.push(resouceDef.list.gridButtons);
            }
        }
        this._currentData.currentListFields = this.rolePermissionService.getAllowedContextMenu(this._currentData.currentListFields, resouceDef.capability, resouceDef.resource);
        console.log("List Fields ", this._currentData.currentListFields);


        if (resouceDef.list.bulkAction) { // This for bulk action
            this._currentData.bulkAction = resouceDef.list.bulkAction;
        }
        if (resouceDef.filter != undefined && resouceDef.filter) {
            let resp = resouceDef.filter[0];
            var obj = [];
            for(let i = 0; i < Object.keys(resp).length; i++) {
                {
                    obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
                }
            }
            obj.toString();
            console.log("Args Values ", obj);
            if (this.currentData != undefined && this.currentData) {
                let obj_ = obj.toString();
                let val = this.baseService.buildDyanamicStr(obj_, { data: this.currentData });
                this._currentData.gridData['filter'] = val;
            }
            else {
                this._currentData.gridData['filter'] = obj;
            }
        }
        // this.baseService.init(resouceDef.resource);
        // this.bindGrid();
        if (resouceDef.args != undefined && resouceDef.args) {
            //this.storageService.getAutofillData('', (res) => {
            if (this.banner && this.banner != undefined) {
                this._currentData.bannerJson = this.banner;
            }
            if (this._currentData.bannerJson != undefined && Object.keys(this._currentData.bannerJson).length > 0) {
                this.getArgs(resouceDef, this._currentData.bannerJson, (response) => {
                    this._currentData.gridData['args'] = response;
                    this.getDataforUiEngine(resouceDef);
                    // console.log("M nbjdksujoiidfn ----- ", this._currentData.gridData)
                });
            } else {
                let resp = resouceDef.args[0];
                let argForQuery = "";
                for(let i = 0; i < Object.keys(resp).length; i++) {
                    argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
                }
                this._currentData.gridData['args'] = argForQuery.substring(0, argForQuery.length - 1);
                this.getDataforUiEngine(resouceDef);
            }
        } else {
            this.getDataforUiEngine(resouceDef);
        }
    }

    getDataforUiEngine(resouceDef) {
        this._currentData.showView = true
        this.baseService.init(resouceDef.resource);
        this._currentData.currentListFields = this.rolePermissionService.getAllowedContextMenu(this._currentData.currentListFields, resouceDef.capability, resouceDef.resource);
        this._currentData.currentListFields = this._currentData.currentListFields.sort((a, b) => { return a.order - b.order });
        if (this._currentData.currentCardFields) {
            this._currentData.cardClassName = this._currentData.currentCardFields.className;
            this._currentData.currentCardFields = this.rolePermissionService.getAllowedContextMenu(this._currentData.currentCardFields.fields, resouceDef.capability, resouceDef.resource);
        }
        if (this._currentData.gridData.page_size == undefined) {
            this._currentData.gridData.page_size = 10;
        }
        if (this._currentData.currentListFields && this._currentData.currentListFields.length > 0 && resouceDef.config && resouceDef.config.projection_keys)
            this._currentData.gridData.projectionKeys = this.baseService.getProjectionKeys(this._currentData.currentListFields, resouceDef.list.projectionKeys);

        //console.log("hsdghgg ",this._currentData);
        if (this._currentData.resouceDef.list.hasOwnProperty('APIresource') && this._currentData.resouceDef.list.APIresource.datasource != undefined) {
            this._currentData.APIresource = this._currentData.resouceDef.list.APIresource.datasource;
            if (this._currentData.APIresource.search != undefined && this._currentData.APIresource.search)
                this._currentData.gridData['search'] = this._currentData.APIresource.search;
            if (this._currentData.APIresource.filter != undefined) {
                if (this._currentData.APIresource.filter.indexOf('!!!') != -1)
                    if (localStorage.currentChildData != undefined)
                        this._currentData.APIresource.filter = this.baseService.buildDyanamicStr(this._currentData.APIresource.filter, { data: JSON.parse(localStorage.currentChildData ? localStorage.currentChildData : null) })
                if (localStorage.currentChildData == undefined)
                    this._currentData.APIresource.filter = this.baseService.buildDyanamicStr(this._currentData.APIresource.filter, { data: JSON.parse(sessionStorage.currentData ? sessionStorage.currentData : null) })
                this._currentData.gridData['filter'] = this._currentData.APIresource.filter;
            }
            if (this._currentData.APIresource.query_id)
                this._currentData.query_id = this._currentData.APIresource.query_id;
            if (!this._currentData.default_filter) {
                this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
            }

        } else {
            if (!this._currentData.default_filter)
                this.bindGrid();
        }
    }

    getByID() {
        this.loader.showSpinner();
        this.baseService.getById(this._currentData.currentId).subscribe(
            (data: any) => {
                if (data.erroCode == -1) {
                    this.alerts.error(data.message);
                } else {
                    console.log("Current Data ", this._currentData);
                    this._currentData.currentData = data;
                }
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                this.alerts.error('API error');
                this.loader.hideSpinner();
            }
        )
    }

    getArgs(resouceDef, bannerJson, callback) {
        if (bannerJson.key != undefined) {
            this._currentData.showBanner = true;
            let resp = resouceDef.args[0];
            let argForQuery = "";
            for(let i = 0; i < Object.keys(resp).length; i++) {
                if (resp[Object.keys(resp)[i]] == '' || resp[Object.keys(resp)[i]] == undefined) {
                    argForQuery = argForQuery + Object.keys(resp)[i] + ":" + bannerJson.key[Object.keys(resp)[i]] + ","
                    //obj.push(Object.keys(resp)[i] + ":" + bannerJson.key[Object.keys(resp)[i]])
                } else {
                    argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
                    //obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
                }
            }
            //obj.toString();
            //console.log("Args Values if ", obj);
            callback(argForQuery.substring(0, argForQuery.length - 1));
        } else {
            var id = this.route.snapshot.queryParams.key;
            var bannerArgs = '';
            if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.query_params)
                bannerArgs = this.route.snapshot.queryParams.query_params;
            else if (bannerJson.datasource['args'] == undefined)
                bannerArgs = "id:" + id;
            else
                bannerArgs = bannerJson.datasource['args'] + ",id:" + id;

            this.baseService.get(bannerJson.datasource.query_id, bannerArgs, bannerJson.datasource.resource, bannerJson.datasource.application).subscribe((res: any) => {
                console.log("data in response in banner detail is :: ", res);
                if (res.erroCode == -1) {
                    return false;
                } else {
                    res = res.resource[0];
                    this._currentData.bannerJson.key = res;
                    this._currentData.showBanner = true;
                    let resp = resouceDef.args[0];
                    let argForQuery = "";
                    for(let i = 0; i < Object.keys(resp).length; i++) {
                        if (resp[Object.keys(resp)[i]] == '' || resp[Object.keys(resp)[i]] == undefined) {
                            argForQuery = argForQuery + Object.keys(resp)[i] + ":" + res[Object.keys(resp)[i]] + ","
                            //obj.push(Object.keys(resp)[i] + ":" + res[Object.keys(resp)[i]])
                        } else {
                            argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
                            //obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
                        }
                    }
                    //obj = obj.toString();
                    //console.log("Args Values else ", obj);
                    callback(argForQuery.substring(0, argForQuery.length - 1));
                }
            });
        }
    }
    bindGrid(resource?, application?, type?, queryId?) {
        this.loader.showSpinner();
        this.config.loadedBindGrid = true;
        var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
        if (this._currentData.configList && this._currentData.configList.ehr_view_default)
            gridData['read_scope_level'] = 'account';
        else if (gridData['read_scope_level'] != undefined)
            delete gridData['read_scope_level'];
        if (this._currentData.parameters) {
            gridData['parameters'] = this._currentData.parameters;
        }

        if (queryId == undefined || queryId == '') {
            gridData['query_id'] = this._currentData.resouceDef.query_id == undefined ? "GET_PAGE" : this._currentData.resouceDef.query_id;
        } else { gridData['query_id'] = queryId == undefined ? "GET_PAGE" : queryId; }

        if (this._currentData.APIresource) {
            resource = this._currentData.APIresource.resource;
            application = this._currentData.APIresource.application;
            gridData['query_id'] = this._currentData.APIresource.query_id;
        }
        if (this._currentData.gridData && this._currentData.gridData.projectionKeys) {
            gridData['projectionKeys'] = this._currentData.gridData.projectionKeys;
        }
        if (this._currentData.APIresource && this._currentData.APIresource.args != undefined && this.commonService.bannerInfo && this.commonService.bannerInfo.val != undefined) {
            gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { data: this.commonService.bannerInfo.val })
        }
        if (this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.checkUrlArgs) {
            gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { 'data': this.activatedRoute.snapshot.queryParams });
        }
        if (this._currentData.configList && this._currentData.configList.secondary_uhid_default)
            gridData['args'] += "," + 'secondary_uhid:true';
        if (this._currentData.configList.readPreference)
            gridData['readPreference'] = this._currentData.configList.readPreference;
        resource = (resource == '' || resource == undefined) ? this._currentData.resource : resource;

        this.utilService.applyArchivePoicy(gridData, false,this);  
        var tempO = this.utilService.applyArchiveArgs(null,gridData['args'],this);
        if(tempO.args != undefined && tempO.args !=""){
            gridData['args'] = tempO.args;
        }

        // #182304 - the same decorator hook ui-engine's own bindGrid() already exposes
        // (ui-engine.component.ts, just before its getData). form-grid's bindGrid never had
        // it, so a decorator had no way to change the grid query here - needed by
        // filter-form-over-grid (FORM_GRID) screens, where submitting the form on top has to
        // re-filter the grid below. Called with the query about to go out, and the callback
        // must reply SYNCHRONOUSLY - getData() fires on the next statement.
        // BaseDecorator.bindGridExtended is a pass-through, so decorators that do not
        // override it are unaffected.
        if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.bindGridExtended != undefined) {
            this._currentData.decorator.bindGridExtended(gridData, resource, application, (val) => {
                gridData = val.gridData; resource = val.resource; application = val.application;
            });
        }

        this.baseService.getData(gridData, "", resource, application).subscribe(
            (data: any) => {
                if (data.erroCode == -1) {
                    this.alerts.error(data.message);
                    if (type == undefined || type == '') {
                        this._currentData.dataList = [];
                    }

                } else {
                    if (type == undefined || type == '') {
                        // #200998 - the same decorator hook ui-engine's bindGrid() already
                        // exposes on its own response (ui-engine.component.ts). form-grid never
                        // had it, so a FORM_GRID screen's decorator could not see what the grid
                        // query returned - needed to tell the user when a submitted filter
                        // matched nothing. BaseDecorator.processDataList is a pass-through, so
                        // decorators that do not override it are unaffected.
                        if (this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processDataList != undefined) {
                            this._currentData.decorator.processDataList(this._currentData, data, (dataR) => {
                                this._currentData.dataList = dataR;
                            });
                        } else {
                            this._currentData.dataList = data;
                        }
                    }
                }
                this.loader.hideSpinner();
                setTimeout(()=>{
                    this.config.loadedBindGrid = false;
                },200)
            }, error => {
                setTimeout(()=>{
                    this.config.loadedBindGrid = false;
                },200)
                console.log(error);
                this.alerts.error('API error');
                this.loader.hideSpinner();
            }
        );
    }

    initCurrentData() {
        this._currentData = {
            'tile_card': false,
            'addAllowed': true,
            'tile': false,
            'table': false,
            'activeField': '',
            'dataList': [],
            'cardList': [],
            'searchList': [],
            'gridData': {},
            "showBanner": false,
            "customClick": false,
            "showView": false
        }
    }


    manupulateArgs(data, args) {
        let tempArgs = JSON.parse(JSON.stringify('!!!' + args + '!!!'));
        let finalargs = [];
        for (let val of data) {
            let strngVal = this.baseService.buildDyanamicStr(tempArgs, { 'data': val });
            finalargs.push(strngVal);
        }
        return args + ":" + finalargs.join('=');
    }

    checkTemplates(event) {
        try {
            this.loader.showSpinner();
            let datasource = this._currentData.resouceDef.config.templateInterceptor.datasource;
            let result = this._currentData.resouceDef.config.templateInterceptor.result_key != undefined ? event.result[this._currentData.resouceDef.config.templateInterceptor.result_key] : event.result;
            result[0]['next_stage'] = this._currentData.resouceDef.config.templateInterceptor.next_stage;
            if (this.commonService.bannerInfo != undefined && this.commonService.bannerInfo.val != undefined && this.commonService.bannerInfo.val.patient_gender_id != undefined && this.commonService.bannerInfo.val.patientType != undefined) {
                result[0]['gender'] = this.commonService.bannerInfo.val.patient_gender_id;
                result[0]['patientType'] = this.commonService.bannerInfo.val.patientType;
            }

            if (result[0] != undefined && !result[0].care_type) {
                try {
                    result[0]['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
                } catch (error) { }
            }
            let args = this.baseService.buildDyanamicStr(datasource.args, { data: result[0] });
            if (datasource.appendArgs != undefined && datasource.appendArgs) {
                args = args + "," + this.manupulateArgs(result, datasource.appendArgs);

            }
            this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
                if (data.errCode != -1 && data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
                    this._currentData.resouceDef.config.templateInterceptor['TemplateData'] = data.resource;
                    this.loader.hideSpinner();
                    this.openTemplIntersep(result, { templateInterceptor: this._currentData.resouceDef.config.templateInterceptor }, false, (res) => {
                        if (res) {
                            event.result[this._currentData.resouceDef.config.templateInterceptor.result_key] = res;
                            this.saveData(event);
                        }
                    });
                }
                else {
                    this.loader.hideSpinner();
                    this.saveData(event);
                }
            })

        } catch (error) {
            this.saveData(event);
        }
    }

    onSaveFinished(event: any) {
        if (this.rolePermissionService.checkAccessPermission('templateInterseptor', this._currentData.currentResource)) {
            //checkPre will determine do we need to hit api to get templates before the popup
            if (this._currentData.resouceDef.config.templateInterceptor.checkPre != undefined && this._currentData.resouceDef.config.templateInterceptor.checkPre) {
                this.checkTemplates(event);
            }

        } else {
            this.saveData(event);
        }
    }

    goBack(){
        if(this.activatedRoute.snapshot.queryParams.hasOwnProperty("returnUrl")){
            this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        }else{
            let current = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
            const url = '/' + this.appService.getApplication() + '/' + current + '/list';
            this.router.navigate([url]);
        }
    }

    saveData(event, callback = null, hideAside = true) {
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this._currentData.decorator != undefined && this._currentData.decorator) {
            this._currentData.decorator.beforeSubmitRequest(event);
        }

        if (this._currentData.decorator != undefined && this._currentData.decorator) {
            var submitInsideDecorator = this._currentData.decorator.submitInsideDecorator(event,(result)=>{
                if(result){
                    this.bindGrid();
                }
            });
            if(submitInsideDecorator){
                return;
            }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        this._currentData.currentAction = event.action ? event.action : this._currentData.currentAction;
        if (this._currentData.currentAction == 'ADD') {
            delete event.result.id;
        }
        var resource = '';
        var application = '';
        var action = '';
        if (this._currentData.currentFormFields.APIresource && this._currentData.currentFormFields.APIresource != undefined) {
            console.log("API Resource", this._currentData.currentFormFields.APIresource);
            resource = this._currentData.currentFormFields.APIresource.datasource['resource'];
            application = this._currentData.currentFormFields.APIresource.datasource['application'];
            if (this._currentData.currentFormFields.APIresource.datasource.action != undefined) {
                action = this._currentData.currentFormFields.APIresource.datasource.action;
            } else {
                action = this._currentData.currentAction;
            }
        } else {
            resource = this._currentData.resouceDef.resource;
            application = '';
            action = this._currentData.currentAction;
        }
        this.loader.showSpinner();

        this.baseService.action(event.result, action, application, resource).subscribe(
            (data: any) => {
                if (data.errCode == -1) {
                    this.alerts.error(data.message);
                    var reuest_handler = false;
                    if (this._currentData.decorator != undefined && this._currentData.decorator) {
                        reuest_handler = this._currentData.decorator.afterErrorRequest(event, data);
                    }
                    if (reuest_handler && this.currentConfig.aside_container != undefined && this.currentConfig.aside_container && this.formComponenet != undefined && this.formComponenet.resetFormClick() != undefined) {
                        this.formComponenet.resetFormClick();
                    }
                    this.bindGrid();
                    if (callback) {
                        callback(false);
                    }
                } else {
                    this.asideBarService.removeComponent();
                    if (this.resourceDef && this.resourceDef.config && this.resourceDef.config.maptemplate) {
                        let obj = { "extra_data": data.resource[0] }
                        this.baseService.action(obj, "initialize_template_group", "form-template-engine", "templateTransaction").subscribe(data => {
                        });
                    }
                    if (event.relayInfo != undefined && event.relayInfo) {
                        this.relayCall(event.relayInfo);
                    }
                    this.communicationService.emitChange({ completed: true });
                    this.editEllipseClick.emit({ data: data.resource[0], 'resource': this._currentData.resource, 'actionType': { 'action': 'savedata' } });
                    if (this._currentData.currentAction == 'ADD') {
                        this.alerts.success("Added Successfully");
                    } else {
                        this.alerts.success("Updated Successfully");
                        if (this.editonPage) {
                            this._currentData.currentAction = 'ADD';
                            this._currentData.currentData = this.currentData;
                            this.baseService.setTitleFromResouceDef(this.resourceDef, this._currentData.currentAction);
                        }
                    }
                    setTimeout(() => {
                        this.bindGrid();
                    })
                    var redirectLogic = true;

                    /******** DEOCRATOR IMPLEMENTATION *******/
                    if (this._currentData.decorator != undefined && this._currentData.decorator) {
                        redirectLogic = this._currentData.decorator.afterSubmitReqSuccess(event, data, this.formComponenet);
                    }
                    /******** DEOCRATOR IMPLEMENTATION *******/

                    if (redirectLogic) {
                        //reset form
                        if (this.formComponenet != undefined && this.formComponenet.resetFormClick() != undefined)
                            this.formComponenet.resetFormClick();
                        //reset banner
                        this.resetBanner();
                    }
                }
                this.loader.hideSpinner();
                if (callback != null) {
                    data['resourceName'] = resource;
                    callback(data);
                }
                if (hideAside)
                    this.asideBarService.removeComponent()
            }, error => {
                console.log(error);
                this.alerts.error('API error');
                this.loader.hideSpinner();
                if (callback) {
                    callback(false);
                }
            }
        )
    }

    refreshFunction(){
        this.asideBarService.subsVar = this.asideBarService.getRefresh().subscribe((val: any) => {
            if(val === true){
              this.bindGrid();
            }
        });
    }

    relayCall(obj) {
        if (obj != undefined) {// when favourite is added
            var relayResource = obj.datasource.resource;
            var relayApplication = obj.datasource.application;
            var relayAction = obj.datasource.action;
            this.baseService.action(obj.map, relayAction, relayApplication, relayResource).subscribe(
                (data: any) => {
                    // Refresh the bookmarks panel so the newly-added favourite shows up
                    // immediately instead of only after a full page reload — bug #182912.
                    // Opt-in via config.refreshBookmarkOnSubmit is true                  
                    if (data && data.errCode == 0 && this.currentConfig?.refreshBookmarkOnSubmit === true && this.formComponenet && this.formComponenet.bookmarkRef) {
                        this.formComponenet.bookmarkRef.getBookMarks(this.formComponenet.bookmarkRef.bookmarks.bookmark['cardData'], undefined, false);
                    }
                })
        }
    }
    resetBanner() {
        if (this._currentData.showBanner) {
            delete this._currentData.bannerJson.key;
            this._currentData.showBanner = false;
            setTimeout(() => {
                this._currentData.showBanner = true;
            })
        }
    }
    customRoute(action, key) {
        if (action.route_path != undefined && action.route_path) {
            //here key is the data of the row
            this.baseService.redirectToOtherPage(action.route_path, key);
        } else {
            console.log("Key ", action, key);
            var app = '';
            if (action.hasOwnProperty('application')) {
                app = action.application;
            } else {
                app = this.appService.getApplication();
            }
            var keyForUrl = '';
            if (action.hasOwnProperty('get_key')) {
                keyForUrl = this.route.snapshot.queryParams.key;
            } else {
                keyForUrl = key.id;
            }
            let url = '';
            if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
                if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
                    url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl, banner: JSON.stringify(action.queryParams) } });
                    } else {
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl } });
                    }
                } else if (action.redirect.action == 'list') {
                    url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                        this.router.navigate([url], { queryParams: { key: keyForUrl, banner: JSON.stringify(action.queryParams) } });
                    } else {
                        this.router.navigate([url], { queryParams: { key: keyForUrl } });
                    }
                } else {
                    url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl, banner: JSON.stringify(action.queryParams) } });
                    } else {
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl } });
                    }
                }
            } else if (action.hasOwnProperty('redirectLink')) {
                action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
                url = '/' + app + '/' + action.redirectLink;
                if (action.hasOwnProperty('queryParams')) {
                    this.router.navigate([url], {
                        queryParams: { returnUrl: this.router.url, key: keyForUrl, banner: JSON.stringify(action.queryParams) }
                    });
                } else {
                    this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl } });
                }
            } else {
                if (action.dependent != undefined && action.dependent) {
                    if (localStorage.getItem('filterValueInForm') == null) {
                        alert("Select filter first");
                    }
                    else {
                        url = '/' + app + '/' + key + '/' + action.resource + '/' + (action.type ? action.type : '');
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl } });
                    }
                }
                else {
                    url = '/' + app + '/' + key + '/' + action.resource + '/' + (action.type ? action.type : '');
                    if (action.hasOwnProperty('queryParams')) {
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl, data: JSON.stringify(action.queryParams) } });
                    } else if (action.hasOwnProperty('new_tab')) {
                        //saurav deep for opening in new tab
                        url = '/' + action['action_name'] + '/' + action['application']
                        window.open(location.origin + url + "?key=" + key[action['key_to_send']]);
                    } else
                        this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: keyForUrl } });
                }
            }
        }
    }
    /**
     * Action handle for DataGrid button event
     * @param menuObj - DataGrid row object with capability json in actionType attrtibute
     */
    buttonAction(menuObj) {
        if(menuObj !=undefined && menuObj.actionType !=undefined && menuObj.actionType.action=="print" &&  menuObj.$event !=undefined && menuObj.$event.ctrlKey != undefined && menuObj.$event.ctrlKey)
        {
          menuObj.actionType.action="print-async";
        }
        switch (menuObj.actionType.action) {
            case "savedata":
                break;
            case "print":
            case "view_file":
            case "download":
                if (menuObj.actionType!=undefined &&  menuObj.actionType.print_barcode!=undefined && menuObj.actionType.print_barcode && this.appService.getAccountConfig().print_barcode!=undefined && this.appService.getAccountConfig().print_barcode) {
                    menuObj.data['fromUiEngine'] = true;
                    this.utilService.printLabel(menuObj.data);
                } else {
                    this.handleFile(menuObj.actionType, menuObj);
                }
                return;
            case "print-async":
                this.handleFile(menuObj.actionType, menuObj);
                return;
            case "checkFromRes":
                this.viewDicom(menuObj.actionType, menuObj.data);
                return
        }
        if (menuObj.actionType != undefined && menuObj.actionType.action != undefined && menuObj.actionType.action != 'add' && menuObj.actionType.action != "delete" && menuObj.actionType.action != "confirm" && menuObj.actionType.action != "aside_modify") {
            if (menuObj.actionType.required_rowData) {
                localStorage.setItem('currentChildData', JSON.stringify(menuObj.data))
            }
            if (menuObj.actionType.useSessionStorageData) {
                menuObj.data = JSON.parse(sessionStorage.currentData)
            }
            if (menuObj.actionType.action == 'custom') {
                this.customRoute(menuObj.actionType, menuObj.data);
            } else {
                let data = menuObj.data;
                let actionType = menuObj.actionType;
                //emitting action for ui engine
                if (!this.editonPage) {
                    if(actionType.action == 'refresh')
                    {
                        this.bindGrid()
                    }else{
                        this.editEllipseClick.emit({ data, actionType });
                    }
                }
                 else {
                    this._currentData.currentAction = "MODIFY";
                    this._currentData.currentData = data;
                    this.baseService.setTitleFromResouceDef(this.resourceDef, this._currentData.currentAction);
                }
            }
        }
        else if (menuObj.actionType != undefined && menuObj.actionType.action != undefined && menuObj.actionType.action == "aside_modify") {
            this.setAsideView(menuObj);
        }
        else if (menuObj.actionType != undefined && menuObj.actionType.action != undefined && menuObj.actionType.action == "delete") {
            this.deleteResourceConfirm(menuObj.data, menuObj.data[menuObj.actionType.key]);
        }
        else if (menuObj.actionType != undefined && menuObj.actionType.action != undefined && menuObj.actionType.action == "confirm") {
            this.confirmBoxResource(menuObj.data, menuObj.actionType);
        }
        else {
            let application = menuObj.actionType.datasource.application;
            let resource = menuObj.actionType.datasource.resource;
            let redirectUrl = menuObj.actionType.redirectUrl;
            this.baseService.action(menuObj.data, this._currentData.currentAction, application, resource).subscribe(
                (data: any) => {
                    this.communicationService.emitChange({ completed: true });
                    if (data.errCode == -1) {
                        this.alerts.error(data.message);
                    } else {
                        this.alerts.success("Added Successfully");
                        this.router.navigate([redirectUrl]);
                    }
                    this.bindGrid();
                    this.loader.hideSpinner();
                }, error => {
                    console.log(error);
                    this.alerts.error('API error');
                    this.loader.hideSpinner();
                }
            )
        }

        //console.log("MenuObj ",menuObj);

    }
    confirmBoxResource(data, action) {
        if (this.dialogRef)
            this.dialogRef.close();

        setTimeout(() => {
            let popupTitle = "";
            this.translateService.translate(action.label).subscribe(x => {
                if (x) {
                    popupTitle = x;
                }
            });
            let name: string = "";
            if (action.name != undefined) {
                name = data[action.name];
            } else {
                name = "";
            }
            const dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm);
            dialogRef.subscribe(result => {
                if (result) {
                    this.loader.showSpinner();
                    if (action.datasource.data != undefined) {
                        var res = action.datasource.data[0];
                        for(let i = 0; i < Object.keys(res).length; i++) {
                            data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
                        }
                        this.confirmResource(data, action);
                    } else {
                        this.confirmResource(data, action);
                    }
                }
            },
                () => { });
        }, 1000)

    }

    confirmResource(data, action) {
        this.baseService.action(data, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
            (data: any) => {
                this.loader.hideSpinner();
                this.communicationService.emitChange({ completed: true });
                if (data.errCode == -1) {
                    this.alerts.error(data.message);
                } else {
                    if (this._currentData.currentAction == 'ADD') {
                        this.alerts.success("Added Successfully");
                    } else {
                        this.alerts.success("Updated Successfully");
                    }
                    if (action.hasOwnProperty('redirectLink')) {
                        let url = ''
                        if (this.router.url.includes('?')) {
                            if (this.router.url.split('?')[0] == action.redirectLink) {
                                url = this.router.url;
                                this.router.navigate(["/search"]).then(() => {
                                    this.router.navigateByUrl(url);
                                });
                            }
                        } else {
                            if (this.router.url == action.redirectLink) {
                                url = this.router.url;
                                this.router.navigate(["/search"]).then(() => {
                                    this.router.navigateByUrl(url);
                                });
                            } else {
                                url = action.redirectLink;
                                this.router.navigateByUrl(url);
                            }
                        }
                    }
                    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
                        this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
                    } else {
                        this.bindGrid();
                    }
                }
                this.loader.hideSpinner();
            }, error => {
                console.log(error);
                this.alerts.error('API error');
                this.loader.hideSpinner();
            }
        )

    }
    onBulkActionClicked(event) {
        event.gridData = this._currentData.gridData;
        this.bulkActionClicked.emit(event);
    }

    limitChanged(event, resource?, application?, type?) {
        this._currentData.gridData.page_no = 0;
        this._currentData.gridData.page_size = event.target.value;
        this.bindGrid(resource, application, type);
    }

    filterChange(event, resource?, application?, type?) {
        this._currentData.gridData.page_no = 0;
        if (typeof event == 'object') {
            this._currentData.gridData.search = event.value;
            this._currentData.gridData.search_columns = event.key;
            this._currentData.gridData.searchColumns = event.key;
            try {
                if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
                  //do nothing
                }
                else{
                    if (event != undefined && event.searchObj != undefined && event.searchObj.eq_search != undefined) {
                    this._currentData.gridData.eq_search = 'y';
                    }
                    else if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.eq_search != undefined) {
                    delete this._currentData.gridData.eq_search;
                    }
                }
            } catch (error) {
            console.log("Form-grid filterChange error : "+error);
            }
        } else {
            this._currentData.gridData.search = event;
        }
        this.bindGrid(resource, application, type);
    }

    pageChanges(event, resource?, application?, type?) {
        this._currentData.gridData.page_no = event - 1;
        this.bindGrid(resource, application, type);
    }

    sortChanges(event, resource?, application?, type?) {
        if (event != undefined && event.frontendSorting != undefined) {
            if (event.clear != undefined && event.clear) {
              delete this._currentData.gridData.frontendSorting;
            } else {
              this._currentData.gridData.frontendSorting = event;
            }
      
          } else {
            if (event && event.form != undefined)
              this._currentData.gridData.filter = event.form
            this._currentData.gridData.page_no = 0;
            // this.updatePageInUrl(this._currentData.gridData.page_no);
            if (event == undefined)
              this._currentData.gridData.order_by = '';
            else
              this._currentData.gridData.order_by = event.key + ' ' + ((event.value == 'desc') ? event.value : '');
            if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
              this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
            } else {
              this.bindGrid(resource, application, type);
            }
          }
        // this._currentData.gridData.page_no = 0;
        // if (event == undefined)
        //     this._currentData.gridData.order_by = '';
        // else
        //     this._currentData.gridData.order_by = event.key + ' ' + ((event.value == 'desc') ? event.value : '');
        // this.bindGrid(resource, application, type);
    }
    deleteResourceConfirm(data, key) {
        let name: string = "";
        if (data.name != undefined) {
            name = data.name;
        } else {
            name = "";
        }
        const dialogRef = this.modalService.confirm('DELETE', 'Are you sure you want to delete ' + name + '?', ModalSize.Sm);
        dialogRef.subscribe(result => {
            if (result) {
                this.deleteResource(key);
            }
        },
            () => { });
    }
    deleteResource(id) {
        var application = '';
        var resource = '';
        if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
            application = this._currentData.APIresource.application;
            if (this._currentData.APIresource.resource != undefined) {
                resource = this._currentData.APIresource.resource;
            }
        }
        this.loader.showSpinner();
        this.baseService.action({ id: id }, 'DELETE', application, resource).subscribe(
            (data: any) => {
                if (data.erroCode == -1) {
                    this.alerts.error(data.message);
                } else {
                    this.alerts.success("Deleted Successfully");
                    this.bindGrid();
                    this.resetBanner();
                }
            }, error => {
                console.log(error);
                this.alerts.error('API error');
            }
        )
    }

    handleFile(action, obj, callback = null) {
        if (action.file_data != undefined) {
            var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
            this.loader.showSpinner();
            var fileObj = JSON.parse(JSON.stringify(action.file_data));
            fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
            fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
            fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : this._currentData.resource;
            fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
            fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
            fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
            fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
            if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
            } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
                fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
            }
            fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);

            if(action.action=="print-async"){
                fileObj.action=action.action;
              }

            this.baseService.handleFile(fileObj, async (fileData) => {
                if (fileData) {
                    if (fileData.type == "application/json") {
                        try {
                            var response = await fileData.text();
                            response = JSON.parse(response);
                            if (response.errCode == -1 && response.message != undefined) {
                                this.alerts.error(response.message);
                            }
                            if (fileObj.action && fileObj.action=="print-async" && response.errCode == 0 && response.message != undefined) {
                                this.alerts.success(response.message,"",true);
                            }
                            console.log(response);
                        } catch (e) {
                            this.alerts.error('API error');
                        }
                    } else {
                        fileObj.key = key;
                        this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
                    }
                } else {
                    this.alerts.error('server error');
                    if (callback) {
                        callback(false);
                    }

                }
                this.loader.hideSpinner();
            }, (error) => {
                this.loader.hideSpinner();
                this.alerts.error('API error');
                if (callback) {
                    callback(false);
                }
            });
        } else {
            console.error("Please provide File Data");
            if (callback) {
                callback(false);
            }
        }
    }

    bindDataToGrid(event) {
        this._currentData.gridData.page_no = 0;
        if (event == undefined || event == '') {
            this._currentData.gridData['filter'] = '';
            this.getFilter();
        }
        else if (event != undefined && event != 'ehr_toggle'){
            this._currentData.gridData['filter'] = '';
            this.getFilter();
            if (this._currentData.gridData['filter'] != "") {
                // This line meant to be if there are default filter and searched filter also. If problem exist consult Aarti
                this._currentData.gridData['filter'] = event + ',' + this._currentData.gridData['filter'];//this line was duplicating the filters and single filter change was not working from grid
            } else {
                this._currentData.gridData['filter'] = event;
            }
            // this._currentData.gridData['filter'] = event;
            /*************Below function is to remove duplicate key from filter string */
            this._currentData.gridData['filter'] = this.filterService.removeDuplicateKeysFromString(this._currentData.gridData);
        }
        if(this._currentData.resouceDef.list.hasOwnProperty('APIresource') && this._currentData?.resouceDef?.list?.APIresource?.datasource?.removedKeyAfterEHROn){
             this.removeEHRButtonKeyRemoveAPI()
        }
        if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
            var datasource = this._currentData.resouceDef.list.APIresource.datasource;
            this.bindGrid(datasource.resource, datasource.application, '', datasource.query_id);
        } else {
            this.bindGrid();
        }
    }

    getFilterValues(filterVal) {
        if (this._currentData.bannerJson && this._currentData.bannerJson.key && this._currentData.bannerJson.key != undefined) {
            filterVal = this.baseService.buildDyanamicStr(filterVal, { data: this._currentData.bannerJson.key });
        } else {
            filterVal = this.baseService.buildDyanamicStr(filterVal, {});
        }
        return filterVal
    }

    getFilter() {
        this._currentData.gridData['filter'] = '';
        if (this._currentData.resouceDef.filter != undefined && this._currentData.resouceDef.filter) {
            let resp = this._currentData.resouceDef.filter[0];
            var obj = [];
            for(let i = 0; i < Object.keys(resp).length; i++) {
                {
                    obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
                }
            }
            obj.toString();
            this._currentData.gridData['filter'] = obj;
        } else if (this._currentData.resouceDef.list && this._currentData.resouceDef.list.APIresource && this._currentData.resouceDef.list.APIresource.datasource && this._currentData.resouceDef.list.APIresource.datasource.filter) {
            this._currentData.gridData['filter'] = this.getFilterValues(this._currentData.resouceDef.list.APIresource.datasource.filter);
        }
    }

    checkConfigForAdd(menuObj?) {
        let datasource = this._currentData.resouceDef.config.config_ADD.datasource;
        this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application).subscribe(res => {
            if (res.errCode == 0 && res.resource && res.resource.length > 0 && res.resource[0].config_value != undefined && res.resource[0].config_value != "") {
                let configValue = res.resource[0].config_value;
                if (this._currentData.resouceDef.config.config_ADD.alert_condition && eval(this._currentData.resouceDef.config.config_ADD.alert_condition)) {
                    this.alerts.error(this._currentData.resouceDef.config.config_ADD.alert_message)
                } else {
                    this.setAsideViewExtended(menuObj);
                }
            } else {
                if (this._currentData.resouceDef.config.config_ADD.alert_message)
                    this.alerts.error(this._currentData.resouceDef.config.config_ADD.alert_message);
                else
                    this.alerts.error("You dont have permission");
            }
        });
    }

    setAsideView(menuObj?) {
        if(this._currentData.resouceDef.config?.config_ADD?.datasource){
            if(this._currentData.resouceDef.config?.config_ADD.condition == undefined){
                this.checkConfigForAdd(menuObj);
            }else if (this._currentData.resouceDef.config?.config_ADD.condition && eval(this._currentData.resouceDef.config?.config_ADD.condition)) {
                this.checkConfigForAdd(menuObj);
            } else {
                this.setAsideViewExtended(menuObj);
            }
        } else {
            this.setAsideViewExtended(menuObj);
        }
    }

    setAsideViewExtended(menuObj?){
        // this.asideBarService.removeComponent();
        var event = {
            required_rowData: menuObj && menuObj.actionType.action && menuObj.actionType.action == 'aside_modify' ? true : false,
            resource: this._currentData.json,
            data: menuObj && menuObj.data ? menuObj.data : {},
            actionType: {
                action_name: menuObj && menuObj.actionType.action ? 'MODIFY' : 'ADD',
                banner: this._currentData != undefined && this._currentData.bannerJson != undefined ? this._currentData.bannerJson : undefined
            }
        };
        let componentConfig = { inputs: { data: event }, container: true };
        // ('aside-modal-container', AsideUiEngineComponent, componentConfig, this.mainObject.blocks[index].size, this.mainObject.page_name.add)
        let size = this._currentData.resouceDef.config.size ? this._currentData.resouceDef.config.size : 'md'
        this.asideBarService.appendComponentTo('aside-modal-container', AsideUiEngineComponent, componentConfig, size, this.layoutName ? this.layoutName : this.baseService._currentTitle).subscribe(data => {
            if (data) {
                this.saveData(data.data, (data_) => {
                    if (data_ && data.data && data.data.currentBtnVal && data.data.currentBtnVal.action == 'add_another') {
                        this.setAsideView()
                    }
                }, false);
            }

        });
    }

    getFilterFromcurrentval(filter, currentData) {
        let val = this.baseService.buildDyanamicStr("!!!a!!!,!!!b!!!", { data: { a: "val1", b: "val2" } });
        debugger;
    }

    openTemplIntersep(data: any, actionType, config?, callback?) {
        let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
        if (config)
            popobj.data['config'] = config
        this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(
            res => {
                if (res) {
                    callback(res);
                }
            });
    }
    emitDefaultFilter() {
        this.bindGrid();
    }
    getConfigValues(event) {
        if (event.resetFilter != undefined && event.resetFilter) {
            if(!this.config.loadedBindGrid){
                this.getFilter();
                this.emitDefaultFilter()
            }
        } else if (event.configureGrid != undefined) {
            this.configUIEngine(event.configureGrid);
        }else if (event.loadArchiveConfig != undefined) {
            this._currentData.archiveConfig.list = event.loadArchiveConfig.list;
          }else if (event.archiveConfig != undefined) {
           
            let archiveConfig:any = false
            if (event.archiveConfig.resource != undefined && this._currentData.archiveConfig != undefined) {
              archiveConfig = this._currentData.archiveConfig;
            }
            this._currentData = false;
            setTimeout(() => {
              this._currentData = {};
              if(archiveConfig){
                archiveConfig.open = false;
                this._currentData.archiveConfig = archiveConfig;
              }
              this.uiInit(event,()=>{
                this.onBulkActionClicked({action:"form_grid_archival",event:event,resourceDef:this.resourceDef,archive_list:this._currentData.archiveConfig.list})
              });
            })
      
        } 
    }

    configUIEngine(config) {
        var obj: any = {};
        obj = { ...obj, ...config };
        obj["key"] = this.getConfigurationKey(config);
        obj["resource_name"] = this._currentData.json;

        this.preferenceService.openConfigurePopup(obj, (response) => {
            if (response.result != undefined) {
                this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
                    console.log(result);
                });
            }
        });
    }

    getConfigurationKey(config) {
        var resourceName = this._currentData.json;
        if (config.context == 'grid') {
            resourceName = this._currentData.resouceDef.resource;
        }
        return this.preferenceService.getConfigurationKey(resourceName);
    }
    loadInitalConfig(resourceName, callback) {
        this.preferenceService.loadInitalConfig(this, resourceName, callback);
    }

        setDiacomUrl(type: string, url: string) {
        this.loader.showSpinner();
        let urlData = url.split("?");
        let token = this.appService.getXsrfToken(urlData[1] || "", true);
        this.baseService.getFileByUrl(url, false).subscribe(res => {
            if (res) {
                let contentType = res.type || "";
                let docId = this.config.documentId ? `&id=${btoa(this.config.documentId)}` : "";
                let listener = this.currentData['listener'] ? `&listener=${btoa(this.currentData['listener'])}` : "";
                this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    `/diacom-viewer/?url=${btoa(url)}&type=${type}&contentType=${contentType}&token=${btoa(token)}${docId}${listener}`
                );
            }
            this.loader.hideSpinner();
        });
    }


    viewDicom(action?: any, item?: any) {
        if (!action?.datasource) return;

        this.loader.showSpinner();
        try {
            const args = action.datasource.args ? this.baseService.buildDyanamicStr(action.datasource.args, { data: item }) : "";
            const filter = action.datasource.filter ? this.baseService.buildDyanamicStr(action.datasource.filter, { data: item }) : "";
            this.baseService.get(action.datasource.queryId, args, action.datasource.resource, action.datasource.application, filter).subscribe({
                next: (res: any) => {
                    const resource = res?.resource?.[0];
                    if (!resource) {
                        console.warn("No DICOM resource found.");
                        return;
                    }

                    // Case 1: Direct PACS image URL available
                    if (resource.pacs_image_url && typeof resource.pacs_image_url === "string") {
                        window.open(resource.pacs_image_url, "_blank", "noopener");
                        return;
                    }

                    // Case 2: PACS image ID provided (with optional annotation data)
                    if (resource.pacs_image_url?.pacs_image_id || resource.pacs_image_id) {
                        if (resource.annotated_data) {
                            localStorage.setItem("annotationJson", resource.annotated_data);
                        }
                        const pacsId = resource.pacs_image_url?.pacs_image_id || resource.pacs_image_id;
                        const url = `${this.baseService.getApiEndpoint("dms")}emrImage/image-response-entity?args=id:${pacsId}&application=dms`;
                        this.setDiacomUrl("file", url);
                        return;
                    }

                    console.warn("DICOM resource found but no valid PACS data.");
                },
                error: (err) => {
                    console.error("Error fetching DICOM:", err);
                },
                complete: () => {
                    this.loader.hideSpinner();
                },
            });
        } catch (e) {
            console.error("Exception in viewDicom:", e);
            this.loader.hideSpinner();
        }
    }

    removeEHRButtonKeyRemoveAPI() {
       const keys = this._currentData.resouceDef.list.APIresource.datasource.removedKeyAfterEHROn.split(',').map(k => k.trim().replace(/[:,]$/, '')).filter(Boolean);
        if (this._currentData.configList.ehr_view_default) {
            // remove all keys
            this._currentData.gridData['filter'] = this._currentData.gridData['filter'].split(',').filter(pair => !keys.some(k => pair.startsWith(k + ':'))).join(',');
        } else {
            // add keys 
            keys.forEach(k => {
                if (!this._currentData.gridData['filter'].includes(k + ':')) {
                this._currentData.gridData['filter'] += `,${k}:${this.commonService.bannerInfo.val[k]}`;
            }});
        }
    }
}